import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px 0;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  align-items: end;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const ContentHeader = styled.header`
  border-bottom: 1px solid #EBEBEB;
  padding: 0 0 20px;

  h2 {
    color: ${({ theme }) => theme.colors.primary[30]};
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;

    text-align: center;
  }
`;

export const ContentBody = styled.body`
  padding: 4px 12px;

  background: ${({ theme }) => theme.colors.white};
`;

export const ContentFooter = styled.footer`
  display: flex;
  gap: 20px;
  justify-content: end;

  padding: 24px 0 0 0;
`;
